import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersBusinessSectionEmployeeConditionSurveysIndexRequestType,
  ApiMembersBusinessSectionEmployeeConditionSurveysIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersBusinessSectionEmployeeConditionSurveysIndexRequestType;
  businessSectionId: string;
  page?: number;
};

const request = async ({
  params,
  businessSectionId,
  page = 1,
}: RequestDataType): Promise<ApiMembersBusinessSectionEmployeeConditionSurveysIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersBusinessSectionEmployeeConditionSurveysIndexResponseType>(
      `/api/members/business_sections/${businessSectionId}/employee_condition_surveys`,
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  params?: ApiMembersBusinessSectionEmployeeConditionSurveysIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersBusinessSectionsEmployeeConditionSurveysIndex = ({
  businessSectionId,
  params,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersBusinessSectionEmployeeConditionSurveysIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    [
      "ApisMembersBusinessSectionsEmployeeConditionSurveysIndex",
      businessSectionId,
      params,
    ],
    ({ pageParam }) => {
      return request({
        businessSectionId,
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
